import { useState, useEffect } from 'react'
import { WhichWeightAPI } from 'WhichWeightAPI'
import moment from 'moment'

import PeriodizationVisualizer from 'components/ProgramGenerator/Periodization/PeriodizationVisualizer'

export default function BasePeriodizationsTab() {

    const [allProgramWeekLengths, setAllProgramWeekLengths] = useState(null)

    const GetAllProgramWeekLengthsFromBackend = async () => {

        const jsonBody = {
            localDate: moment().local().format('YYYY-MM-DD')
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('PROGRAM', 'GET', '/generate_all_program_week_lengths', jsonBody)

        // console.log(result);

        setAllProgramWeekLengths(result.data.data)

    }

    useEffect(() => { GetAllProgramWeekLengthsFromBackend() }, [])

    if (allProgramWeekLengths === null) {
        return (
            <div className="space-y-4">
                <div className="w-full h-40 bg-gray-200 rounded-xl" />
                <div className="w-full h-40 bg-gray-200 rounded-xl" />
                <div className="w-full h-40 bg-gray-200 rounded-xl" />
                <div className="w-full h-40 bg-gray-200 rounded-xl" />
            </div>
        )
    }

    return (
        <div className="space-y-4">
            {Object.keys(allProgramWeekLengths).reverse().map((key) => (
                <PeriodizationVisualizer
                    key={key}
                    label={`${key} weeks`}
                    periodizationArray={allProgramWeekLengths[key]}
                />
            ))}
        </div>
    )
}